import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=6babe2c1"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6babe2c1')) {
      api.createRecord('6babe2c1', component.options)
    } else {
      api.reload('6babe2c1', component.options)
    }
    module.hot.accept("./ActivityDetail.vue?vue&type=template&id=6babe2c1", function () {
      api.rerender('6babe2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/employee/ActivityDetail.vue"
export default component.exports